<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("user log") }}
      </h1>
    </div>

    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("user") }}</label>
          <div class="control">
            <div class="select is-fullwidth">
              <select v-model="meta.user_id">
                <option value="null">{{ $t("all") }}</option>
                <option
                  v-for="user in users"
                  :key="user.user_id"
                  :value="user.user_id"
                >
                  {{ user.username }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="column">
        <div class="field">
          <label class="label">{{ $t("query") }}</label>
          <div class="control">
            <button class="button is-rounded is-primary" @click="query">
              <span class="icon"><i class="fa fa-bolt"></i></span>
              <span>{{ $t("query") }}</span>
            </button>
          </div>
        </div>
      </div> -->
    </div>

    <generic-table
      ref="datatable"
      :title="$t('user log')"
      :columns="columns"
      :column_search="true"
      resource_url="/apis/system/user-log"
      :extra_data="{ user_id: meta.user_id }"
    >
    </generic-table>
  </section>
</template>

<script>
import {
  get,
  generate_datatables_buttons,
  error_message,
  put,
  del,
  confirm_deletion_dialog,
  success_message,
  format_date_time,
  format_time,
} from "@/utils";
import GenericTable from "@/components/generic_table/GenericTable.vue";

export default {
  components: { GenericTable },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          searchable: false,
          width: "15%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return `${v.format_date_time(row.create_date)} ${v.format_time(
              row.create_date
            )}`;
          },
        },
        {
          title: v.$t("path"),
          searchable: true,
          width: "20%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return `<div class="ui list">
                        <div class="item">${v.$t("module")}: ${
              row.resource.module.code_name
            }</div>
                        <div class="item">${v.$t("path")}: ${row.path}</div>
                        <div class="item">${
                          row.resource.path_regular_expression
                        }</div>
                        <div class="item">${row.resource.http_method}</div>
                    </div>`;
          },
        },
        {
          title: v.$t("request data"),
          searchable: true,
          width: "30%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return JSON.stringify(row.request_data);
          },
        },
        {
          title: v.$t("response data"),
          searchable: true,
          width: "30%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return JSON.stringify(row.response_data);
          },
        },
        // {
        //   title: v.$t("options"),
        //   width: "15%",
        //   searchable: false,
        //   data: (row) => {
        //     return generate_datatables_buttons([
        //       // {
        //       //   args: { uuid: row.uuid },
        //       //   tooltip: v.$t("edit"),
        //       //   icon: "fa fa-edit",
        //       //   icon_class: "is-small",
        //       //   click: function (e) {
        //       //     // console.log("edit order", e.detail.uuid);
        //       //     v.$refs.provider_modal.show_modal(e.detail.uuid);
        //       //   },
        //       // },
        //       {
        //         args: { uuid: row.uuid },
        //         tooltip: v.$t("delete"),
        //         icon: "fa fa-trash",
        //         icon_class: "is-small has-text-danger",
        //         click: (e) => {
        //           let uuid = e.detail.uuid;
        //           confirm_deletion_dialog(
        //             v.$t("are you sure to delete movement?"),
        //             v,
        //             () => {
        //               del("/inventory/movement", { uuid: uuid })
        //                 .then(() => {
        //                   v.refresh();
        //                 })
        //                 .catch((error) => {
        //                   error_message(error);
        //                 });
        //             }
        //           );
        //         },
        //       },
        //     ]);
        //   },
        // },
      ],
      users: [],
      meta: {
        user_id: null,
      },
    };
  },
  computed: {},
  methods: {
    format_date_time,
    format_time,
    query() {
      let v = this;
      get("/apis/system/user-log", { user_id: v.meta.user_id })
        .then((r) => {
          console.log("user log", r);
        })
        .catch((error) => {
          error_message(error);
        });
    },
  },
  mounted() {
    let v = this;
    get("/apis/system/users", {})
      .then((r) => {
        v.users = r;
      })
      .catch((error) => {
        error_message(error);
      });
  },
};
</script>

<style>
/* Add Bulma styles here */
</style>
